import { createOwnedDbHelpers } from "@9amhealth/shared";
import Dexie from "dexie";
import { StorageController } from "src/state/StorageBloc/StorageBloc";
import type {
  CachedConversation,
  CachedFile,
  CachedMessage,
  SyncMeta
} from "./dbTypes";

const DB_OWNER_KEY = "leapchat-db-owner";

class LeapChatDb extends Dexie {
  conversations!: Dexie.Table<CachedConversation, string>;
  messages!: Dexie.Table<CachedMessage, string>;
  syncMeta!: Dexie.Table<SyncMeta, string>;
  cachedFiles!: Dexie.Table<CachedFile, string>;

  constructor() {
    super("LeapChatDb");

    this.version(1).stores({
      conversations: "id, updatedAt",
      messages: "id, conversationId, createdAt, [conversationId+createdAt]",
      syncMeta: "key"
    });

    this.version(2).stores({
      prompts: "id, conversationId, messageId"
    });

    this.version(3).stores({
      cachedFiles: "id, cachedAt"
    });
  }
}

let instance: LeapChatDb | null = null;

export const getDb = (): LeapChatDb => {
  if (!instance) {
    instance = new LeapChatDb();
  }
  return instance;
};

const helpers = createOwnedDbHelpers(getDb(), {
  ownerKey: DB_OWNER_KEY,
  getCurrentOwnerId: () => StorageController.activeUserId
});

export const ensureOwnership = helpers.ensureOwnership;
export const invalidateOwnership = helpers.invalidateOwnership;
export const clearDb = helpers.clearAll;
